import React, { useEffect, useReducer, useState } from 'react'
import { Button, Card, Col, Row, Table } from 'react-bootstrap'
import { BarChart } from '../../../../UI/graphs/BarChart'
import { barChartConfig } from '../../../../../config/barChartConfig'
import axiosInstance from '../../../../../config/axios'
import { listingInitialState, listingReducer } from '../../../pollStats/reducers/listingReducer'
import ModuleDisplayEmail from '../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail'
import ModuleDisplayPhone from '../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone'


export default function PollQuestion({ question }) {
    const [chartData, setChartData] = useState({})
    const [selectedBarId, setSelectedBarId] = useState(null)
    const [listingState, listingDispatch] = useReducer(listingReducer, listingInitialState)

    const clickHandler = (id, label, value) => {
        //console.log(id, label, value)
        if (id !== selectedBarId) {
            setSelectedBarId(id)
        }
    }

    const loadDataInFavourSubmissions = async () => {
        listingDispatch({
            type: "FETCH_REQUEST"
        });
        try {
            const res = await axiosInstance.get(`/poll-stats/option-favours/${selectedBarId}`)//
            listingDispatch({
                type: "FETCH_SUCCESS",
                payload: res.data
            });
        } catch (error) {
            listingDispatch({
                type: "FETCH_FAILURE",
                payload: error
            });
        }
    }

    useEffect(() => {
        //console.log("selectedBarId =>", selectedBarId)
        if (selectedBarId) {
            loadDataInFavourSubmissions();
        }
    }, [selectedBarId])

    useEffect(() => {
        setChartData({ showGraph: false })
        setSelectedBarId(null);
        listingDispatch({
            type: "FETCH_SUCCESS",
            payload: []
        });

        let questionBarChartConfig = barChartConfig
        questionBarChartConfig.showGraph = false;

        let labels = []
        let data = []
        let ids = []
        question.options.map((option) => {
            labels.push(option.option)
            data.push(option.favourSubmissionsCount)
            ids.push(option._id)
        })
        questionBarChartConfig.datasets[0].label = question.question
        questionBarChartConfig.datasets[0].data = data
        questionBarChartConfig.datasets[0].ids = ids
        questionBarChartConfig.labels = labels
        questionBarChartConfig.showGraph = true;

        setTimeout(
            () => { setChartData(questionBarChartConfig) },
            200
        );
    }, [question])

    return (
        <div className="my-2 mx-3">
            <h5>{question.question}</h5>
            <h6 className="font-italic mx-3">- Total Submissions: <span className="cutsomText-red text-bold">{question.submissionsCount}</span></h6>
            <h5 className="mt-3 mx-3">Summary</h5>
            <ul>
                {question.options.map(option => {
                    return <li className='font-italic'>{option.option} ({option.favourSubmissionsCount})</li>
                })}
            </ul>


            {
                (chartData && chartData.showGraph) && <>
                    <Row>
                        <Col className="col-6 chartDisplay">
                            <Card className='px-3'>
                                <BarChart chartData={chartData} key={question._id} clickHandler={clickHandler} />
                            </Card>
                        </Col>
                    </Row>

                </>
            }

            {(listingState.data.items && listingState.data.items.length > 0) && <>
                {selectedBarId && (
                    <h5 className="my-3">
                        List of members who selected{" "}
                        {question.options
                            .filter((item) => item._id === selectedBarId)
                            .map((option) => {
                                return (
                                    <span className="font-italic font-weight-bold">
                                        "{option.option}"
                                    </span>
                                );
                            })}{" "}
                        
                    </h5>
                )}
                <div className="favoursSubmissions mt-3">
                    <div className="registrationTable overflow-auto m-0 p-0 mt-2">
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th className="text-center">#</th>
                                    <th className="text-center">Name</th>
                                    <th className="text-center">Email</th>
                                    <th className="text-center">Mobile</th>
                                    <th className="text-center">Nationality</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    listingState.data.items.map((item, index) => {
                                        return <tr index={index}>
                                            <td className="text-center">{index + 1}</td>
                                            <td><Button href={`/members/${item._id}`} variant="link">{item.fullName}</Button></td>
                                            <td><ModuleDisplayEmail value={item.email} /></td>
                                            <td><ModuleDisplayPhone value={item.mobile} /></td>
                                            <td>{item.nationality}</td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </Table>
                    </div>
                </div>
            </>}

        </div>
    )
}
